import { render, staticRenderFns } from "./Lista-Pratiche-Dottore.vue?vue&type=template&id=7a788012&scoped=true&"
import script from "./Lista-Pratiche-Dottore.vue?vue&type=script&lang=js&"
export * from "./Lista-Pratiche-Dottore.vue?vue&type=script&lang=js&"
import style0 from "./Lista-Pratiche-Dottore.vue?vue&type=style&index=0&id=7a788012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a788012",
  null
  
)

export default component.exports